/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchIndexKey } from './searchIndexKey';


export interface SearchIndexActivation { 
    searchIndexKey: SearchIndexKey;
    /**
     * The type of this Search Index. One of the following values: BUS_OBJCT_DFNTN, TAG
     */
    searchIndexType: string;
    /**
     * The status of this Search Index. One of the following values: BUILDING, READY
     */
    searchIndexStatus: string;
    /**
     * A flag to indicate if the index is active or not. If the index is active it will be included in the search results.                
     */
    active?: boolean;
    /**
     * The User ID of the user who created this Search Index
     */
    createdByUserId?: string;
    /**
     * The timestamp when this Search Index was created on
     */
    createdOn?: Date;
    /**
     * The timestamp when this Search Index was last updated on
     */
    lastUpdatedOn?: Date;
}
